import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "./frontend.css";
import frameImage1 from "../public/images/preluare_mandat_MP.png";
import frameImageBG1 from "../public/images/preluare_mandat_negativ_MP.png";
// import frameImage2 from "../public/images/frame_votez_MNP_MP.png";
// import frameImageBG2 from "../public/images/frame_votez_MNP_MP_BG.png";
// import frameImage2 from "../public/images/frame_multumesc_pentru_vot.png";
// import frameImageBG2 from "../public/images/frame_multumesc_BG.png";
import { fabric } from "fabric";
import { Flex, FlexItem, FlexBlock, Button } from "@wordpress/components";
import SquareGrid from "./components/SquareGrid";

const divsToUpdate = document.querySelectorAll(".vote-frame-update-me");

divsToUpdate.forEach((div) => {
  ReactDOM.render(<Framer />, div);
  div.classList.remove(".vote-frame-update-me");
});

function Framer() {
  const WIDTH = 300;
  const HEIGHT = 300;
  const canvasRef = useRef(null);
  const [canvas, setCanvas] = useState({});
  const [clipPather, setClipPather] = useState({});
  const [theFrame, setTheFrame] = useState({});
  const [currentImageInCanvas, setCurrentImageInCanvas] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedFrame, setSelectedFrame] = useState(null);
  const arrayOfDivs = [
    [frameImage1, frameImageBG1],
    // [frameImage2, frameImageBG2],
  ];

  // function isInAppBrowser() {
  //   var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  //   // Detect Facebook in-app browser
  //   if (userAgent.indexOf("FBAN") > -1 || userAgent.indexOf("FBAV") > -1) {
  //     return true;
  //   }
  //   return false;
  // }

  // if (isInAppBrowser()) {
  //   alert(
  //     "Please open this link in your default browser to download the image."
  //   );
  //   // Provide a link for the user to click and open in their default browser
  // }

  const loadImage = (url) => {
    // console.log(canvas.getObjects());
    if (currentImageInCanvas) {
      canvas.remove(currentImageInCanvas);
    }
    fabric.Image.fromURL(url, (img) => {
      // console.log(canvas.getObjects());
      setCurrentImageInCanvas(img);
      img.scaleToHeight(canvas.height);
      img.scaleToWidth(canvas.width);
      canvas.add(img);
      canvas.setActiveObject(img);
      img.clipPath = clipPather;
      // canvas.sendToBack(img);
    });
  };

  const loadImageBetweenFrames = (
    urlOfTheSelectedFrame,
    urlOfTheSelectedBGFrame
  ) => {
    if (currentImageInCanvas) {
      canvas.remove(currentImageInCanvas);
    }
    fabric.Image.fromURL(urlOfTheSelectedFrame, (img) => {
      // console.log(canvas.getObjects());
      setCurrentImageInCanvas(img);
      img.scaleToHeight(canvas.height);
      img.scaleToWidth(canvas.width);
      canvas.add(img);
      canvas.setActiveObject(img);
      img.clipPath = urlOfTheSelectedBGFrame;
      // canvas.sendToBack(img);
    });
  };

  function frameInCanvas(frameUrl, frameBGUrl, uploadedImageStatus = "") {
    if (canvas.getObjects().length > 0) {
      canvas.clear();
    }
    fabric.Image.fromURL(frameUrl, (frameImg) => {
      frameImg.set({
        selectable: false,
        lockMovementX: true,
        lockMovementY: true,
      });
      setTheFrame(frameImg);
      frameImg.scaleToHeight(canvas.height);
      frameImg.scaleToWidth(canvas.width);
      canvas.add(frameImg);
      canvas.renderAll();
    });

    fabric.Image.fromURL(frameBGUrl, (frameImg) => {
      frameImg.set({
        selectable: false,
        absolutePositioned: true,
      });
      setClipPather(frameImg);
      frameImg.scaleToHeight(canvas.height);
      frameImg.scaleToWidth(canvas.width);
      canvas.sendToBack(frameImg);
      // canvas.add(frameImg);
      if (uploadedImageStatus !== "discarded" && uploadedImage !== null) {
        loadImageBetweenFrames(uploadedImage, frameImg);
      }
    });
    // setUploadedImage(null);
  }

  const addCustomFrame = (frameUrl, frameBGUrl) => {
    const canvas = new fabric.Canvas(canvasRef.current, {
      backgroundColor: "#eee", // Set canvas background color
      width: WIDTH,
      height: HEIGHT,
    });
    setCanvas(canvas);

    fabric.Image.fromURL(frameUrl, (frameImg) => {
      frameImg.set({
        selectable: false,
        lockMovementX: true,
        lockMovementY: true,
      });
      setTheFrame(frameImg);
      frameImg.scaleToHeight(canvas.height);
      frameImg.scaleToWidth(canvas.width);
      canvas.add(frameImg);
      canvas.renderAll();
    });

    // frame Image
    // Filler Image (what's inside the frame)
    fabric.Image.fromURL(frameBGUrl, (frameImg) => {
      frameImg.set({
        selectable: false,
        absolutePositioned: true,
      });
      setClipPather(frameImg);
      frameImg.scaleToHeight(canvas.height);
      frameImg.scaleToWidth(canvas.width);
      canvas.sendToBack(frameImg);
      // canvas.add(frameImg);
    });
  };

  useEffect(() => {
    addCustomFrame(frameImage1, frameImageBG1);
  }, []);

  useEffect(() => {
    if (selectedFrame) {
      frameInCanvas(selectedFrame[0], selectedFrame[1]);
      // console.log(canvas.getObjects());
    }
  }, [selectedFrame]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setUploadedImage(e.target.files[0]);
    const reader = new FileReader();
    reader.onload = (event) => {
      const imageUrl = event.target.result;
      loadImage(imageUrl);
      setUploadedImage(imageUrl);
    };
    reader.readAsDataURL(file);
  };

  function resizeCanvas(newWidth, newHeight) {
    var scaleFactorX = newWidth / canvas.width;
    var scaleFactorY = newHeight / canvas.height;

    canvas.setWidth(newWidth);
    canvas.setHeight(newHeight);

    canvas.getObjects().forEach(function (obj) {
      obj.left *= scaleFactorX;
      obj.top *= scaleFactorY;
      obj.scaleX *= scaleFactorX;
      obj.scaleY *= scaleFactorY;
    });

    canvas.discardActiveObject().renderAll();
  }

  // Function to download the canvas as an image
  const downloadImage = () => {
    resizeCanvas(WIDTH * 2, HEIGHT * 2);
    // canvas.discardActiveObject().renderAll();
    const dataUrl = canvasRef.current.toDataURL({
      format: "png",
      quality: 1,
    });
    const link = document.createElement("a");
    link.download = `image_with_frame_${new Date().getTime()}.png`;
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    resizeCanvas(WIDTH, HEIGHT);
    if (selectedFrame) {
      frameInCanvas(selectedFrame[0], selectedFrame[1], "discarded");
    } else {
      initialSetup(frameImage1, frameImageBG1);
    }

    setUploadedImage(null);
  };

  return (
    <Flex className="wrapper">
      <div className="framer-container">
        <label className="upload-label" for="imageUpload">
          Încarcă fotografie
        </label>
        <input
          id="imageUpload"
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          style={{ display: "none" }}
        />
        <canvas
          className="canvas"
          ref={canvasRef}
          onChange={(e) => {
            console.log(e);
          }}
        ></canvas>
        <SquareGrid array={arrayOfDivs} setSelectedFrame={setSelectedFrame} />
        <FlexBlock className="button-container">
          <Button
            className={!uploadedImage ? "disabled" : "download-button"}
            onClick={downloadImage}
            disabled={!uploadedImage}
          >
            Descarcă fotografie
          </Button>
          {/* <p style={{ color: "white" }}>salut</p> */}
        </FlexBlock>
      </div>
    </Flex>
  );
}
